import WarningIcon from "@/assets/icons/WarningIcon";
import { Box, Typography } from "@mui/material";

export default function CaktoApiWarningCopykeys() {
    return (
        <Box sx={{ padding: 2, borderRadius: 1, bgcolor: 'background.paper', display: 'flex', gap: 1, }} >
            <Box sx={{ marginTop: 1 }} >
                <WarningIcon />
            </Box>
            <Typography variant="body2" fontWeight={700} >
                Copie e salve suas chaves agora, por segurança elas não poderão ser exibidas novamente.
            </Typography>
        </Box>
    )
}